/**
 * Quitte l'app pour une page Stripe (paiement, portail client). Une réponse sans
 * URL est une erreur : l'appelant l'affiche comme les autres.
 */
export function goToStripe(url: string | null | undefined): void {
  if (!url) throw new Error('STRIPE_URL_MISSING')
  window.location.assign(url)
}
